import React ,{Component} from 'react'
import icon_category from '../../resources/category.png';
var view_util = require('../../../utilities/ViewUtil');

export default class PriceFeeDialog extends Component {

  constructor(props) {
    super(props);
    this.state={
    ...props.data.state
  }
  }

  render() {
    return (
            <div className='process_dialog_root layer_a'>
                <div className='product_dialog_container layer_b'>
                    <div className='wrapper_form_product normal_padding_bottom default_text_medium_gray bold_text normal_border_bottom'>
                        Product Fee
                    </div>
                    <div className='vertical_margin'>
                        {view_util.getDropdownView(this, 'category', icon_category, 'Kategori', true, true, true, true)}
                    </div>
                    <div className='wrapper_form_product center_content_b normal_border_bottom normal_padding_bottom'>
                        <table className='table_data_product_fee vertical_margin'>
                            <thead className=''>
                                <tr>
                                    <th className='whole_padding default_text_normal_gray'>
                                        Category
                                    </th>
                                    <th className='whole_padding default_text_normal_gray'>
                                        Presentase Fee
                                    </th>
                                    <th className='whole_padding default_text_normal_gray'>
                                        Amount Fee
                                    </th>
                                    <th className='whole_padding default_text_normal_gray'>
                                        Action
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className='whole_padding default_text_normal_gray'>
                                        Category
                                    </td>
                                    <td className='whole_padding default_text_normal_gray'>
                                        Presentase Fee
                                    </td>
                                    <td className='whole_padding default_text_normal_gray'>
                                        Amount Fee
                                    </td>
                                    <td className='whole_padding default_text_normal_gray'>
                                        Action
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>
                        {/* <button onClick={this.props.onClose()}>close</button> */}
                    </div>
                </div>
            </div>
        )
    }
}